import { Bodytext, Button, Heading, Page } from '@acorns/web-components'
import styled from 'styled-components'

import Grid from 'pages/invest/Grid'
import { style } from 'theme'

export const Container = styled.div`
  align-items: center;
  margin: auto;
  max-width: 800px;
  background: ${style((theme) => theme.colors.white)};
  @media screen and (min-width: ${style(
      (theme) => theme.breakpoints.sm + 1,
    )}px) {
    width: 100%;
    box-shadow: ${style((theme) => theme.shadows.lgMedium)};
    border-radius: ${style((theme) => theme.borderRadius.large)};
  }
`
export const Content = styled.div<{ isOnboarding?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 50px;
  position: relative;
  width: 100%;
  ${(props) => props.isOnboarding && 'padding-bottom: 0px;'};
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding: 35px 30px 30px;
    ${(props) => props.isOnboarding && 'padding-bottom: 0px;'};
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 480px;
  text-align: center;
  margin: 0 auto 10px;
`

export const HeadingStyled = styled(Heading)`
  font-size: 22px;
  line-height: 30px;
  margin-bottom: 10px;
  align-items: center;
  display: flex;
  max-width: 350px;
`

export const StyledHeaderBodyText = styled(Bodytext)`
  max-width: 450px;
  min-height: 45px;
`

export const ChangePortfolioButton = styled(Button)`
  margin-top: 30px;
  margin-bottom: 30px;
  width: 220px;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    margin-top: 0px;
    width: 335px;
  }
  @media screen and (max-width: 330px) {
    width: 300px;
  }
`

export const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  align-items: center;
  border-top: 1px solid ${style((theme) => theme.colors.ivory)};
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    border-top: none;
  }
`

export const LearnMorePortfolioAction = styled.button`
  all: unset;
  width: 44px;
  height: 44px;
  border-radius: 100%;
  background: ${style((theme) => theme.colors.ivory)};
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    background: ${style((theme) => theme.colors.white)};
  }
`

export const StyledGrid = styled(Grid)`
  padding: 50px;
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding: 50px 30px;
  }
`

export const StyledPage = styled(Page)`
  @media (max-width: ${style((theme) => `${theme.breakpoints.sm}px`)}) {
    > div {
      padding: 0px;
    }
  }
`
